export default "__VITE_ASSET__9Q5pv2gS__"